<template>
  <dv-scroll-board :config="config" style="width:100%;height:340px" />
</template>

<script>
//专区排行
export default {
  name: "Consumption2",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {

    let user_id = window.localStorage.getItem('user_id');

    const data = {
      'user_id': user_id
    };
    this.$api.zgu_real_order(data).then(res=>
    {
      // console.log(res);
      this.config = {
        header: ['商品名称', '专柜名称', '购买金额', '帮扶金额', '购买人id','购买时间'],
        rowNum:[6],
        data: res,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: true,
        columnWidth: [40,200,350],
        align: ['center']
      }
    })


  },

  watch: {

  }
}
</script>

<style scoped>
.galleries {
  width: 100%;
  height: 100%;
}
</style>